import { CLOSE } from 'actions/eventsWidgetSoundSettings';

const defaultState = {
  shown: false,
};

export default function eventsWidgetSoundSettings(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case 'SHOW_EVENTS_WIDGET_CHOOSE_SOUNDS_MODAL':
      return {
        shown: true,
        ...action.payload,
      };
    case CLOSE:
      return {
        shown: false,
      };
    default:
      return state;
  }
}
